export const DAILY_GOALS = Object.freeze({
  speak: [1200, 2500],
  listen: [2400],
});

export const BENEFITS = [
  'rich-data',
  'improve-audio',
  'keep-track',
  'compare-progress',
  'view-goals',
  'join-newsletter',
];

export const WHATS_PUBLIC = [
  'email-not-public',
  'recordings-and-locale-public',
  'username-optin-public',
  'demographic-deidentified-clarity-2',
  'username-email-not-demographic',
];

/**
      'process.env.USERNAME': JSON.stringify(process.env.USERNAME),
      'process.env.PASSWORD': JSON.stringify(process.env.PASSWORD),
      'process.env.ADMIN_USERNAME': JSON.stringify(process.env.ADMIN_USERNAME),
      'process.env.ADMIN_PASSWORD': JSON.stringify(process.env.ADMIN_PASSWORD),
      'process.env.API_PATH': JSON.stringify(process.env.API_PATH),
      'process.env.DEVICES_PATH': JSON.stringify(process.env.DEVICES_PATH),
      'process.env.TERMS_ES': JSON.stringify(process.env.TERMS_ES),
      'process.env.TERMS_EN': JSON.stringify(process.env.TERMS_EN),
 */

declare const __TITLE_EN: string,
  __TITLE_ES: string,
  __COMMON_USERNAME: string,
  __COMMON_PASSWORD: string,
  __ADMIN_USERNAME: string,
  __ADMIN_PASSWORD: string,
  __API_PATH: string,
  __DEVICES_PATH: string,
  __TERMS_ES: string,
  __TERMS_EN: string,
  __MUST_CHECK: boolean,
  __APP_TITLE: string;

type env = {
  title_es: string;
  title_en: string;
  username: string;
  password: string;
  admin_username: string;
  admin_password: string;
  api_path: string;
  devices_path: string;
  terms_es: string;
  terms_en: string;
  must_check: boolean;
  title: string;
};

let environemnt: env = {
  title_es: null,
  title_en: null,
  username: null,
  password: null,
  admin_username: null,
  admin_password: null,
  api_path: null,
  devices_path: null,
  terms_es: null,
  terms_en: null,
  must_check: false,
  title: null,
};
try {
  environemnt = {
    title_es: __TITLE_ES || null,
    title_en: __TITLE_EN || null,
    username: __COMMON_USERNAME || null,
    password: __COMMON_PASSWORD || null,
    admin_username: __ADMIN_USERNAME || null,
    admin_password: __ADMIN_PASSWORD || null,
    api_path: __API_PATH || null,
    devices_path: __DEVICES_PATH || null,
    terms_es: __TERMS_ES || null,
    terms_en: __TERMS_EN || null,
    must_check: __MUST_CHECK || false,
    title: __APP_TITLE || null,
  };
} catch (ex) {
  console.log('Cannot define environment...');
}
export const ENVIRONMENT: env = environemnt;
